import React from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import FooterOne from '../../common/footer/FooterOne';
import Banner from '../../components/solutions/public-sector/Banner';
import AISolutions from '../../components/solutions/public-sector/AISolutions';
import CaseStudy from '../../components/solutions/public-sector/CaseStudy';
import PublicSectorTransformation from '../../components/solutions/public-sector/PublicSectorTransformation';
import Advantage from '../../components/solutions/public-sector/Advantage';
import FooterBanner from '../../components/solutions/public-sector/FooterBanner';

const PublicSector = () => {

  return (
    <>
      <SEO
				title="Public Sector AI Solutions"
				description="Enabling Data-Driven, Transparent, and Equitable Public Services with AI"
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <Banner />
      <AISolutions />
      <CaseStudy />
      <PublicSectorTransformation />
      <Advantage />
      <FooterBanner />
      <FooterOne />
    </>
  )
}

export default PublicSector;